module.exports = __webpack_public_path__ + "img/sld_inverter_t1_green.68f0a363.svg";